import { useSelector } from "react-redux"
import { header, expandedHeader } from "styles/theme"

const useHeaderHeight = () => {

    const { isExpanded } = useSelector(state => state.header)

    return isExpanded ? expandedHeader : header
}

export default useHeaderHeight